import { useEffect, useState } from 'react';
import Styles from './Weather.module.scss';
import UnknownWeatherIcon from "../../icons/weather_icons/unknown.png"

const Weather = () => {

    const [error, setError] = useState("")

    const [iconSrc, setIconSrc] = useState("")

    const [weather, setWeather] = useState({
        value: 0,
        label: "Error",
        city: "",
        country: ""
    })
    const KELVIN = 273;
    const regex1 = /User/ig;
    const regex2 = /user/ig;

    const setPosition = (position: any) => {
        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;

        getWeather(latitude, longitude);
    }

    function showError(error: any) {
        var text = String("Error occured : "+error.message).replace(regex1,"You")
        text = text.replace(regex2,"you")
        setError(text)
    }


    const loadImage = async (imageName: string) => {
        await import(`../../icons/weather_icons/${imageName}.png`)
            .then((image) => {
                setIconSrc(image.default);
            })
            .catch((error) => {
                console.error('Error loading the image:', error);
            });
    }

    const getWeather = async (latitude: any, longitude: any) => {

        let api = `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=${process.env.REACT_APP_WEATHER_API_KEY}`;

        await fetch(api)
            .then(function (response) {
                let data = response.json();
                return data;
            })
            .then(function (data) {
                setWeather(
                    {
                        value: Math.floor(data.main.temp - KELVIN),
                        label: data.weather[0].description[0].toUpperCase() + data.weather[0].description.slice(1),
                        city: data.name,
                        country: data.sys.country,
                    }
                )
                loadImage(data.weather[0].icon)
            })
    }

    useEffect(() => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(setPosition, showError);
        } else {
            console.log("error in geolocation")
        }
    }, [])

    return (
        <div className={Styles.main_weather_container}>
            {
                error
                    ? <div className={Styles.error}> {`${error}`} </div>
                    :
                    <>
                        <div className={Styles.location}>
                            {`${weather.city}, ${weather.country}`}
                        </div>
                        <div className={Styles.temprature}>
                            {`${weather.value}°`}
                        </div>
                        <div className={Styles.icon}>
                            <img src={iconSrc || UnknownWeatherIcon} />
                        </div>
                        <div className={Styles.weather_label}>
                            {weather.label}
                        </div>
                    </>
            }
        </div>
    )
}

export default Weather
